import styled from 'styled-components';

export const ExpertSec = styled.section`
  display: grid;
  grid-template-columns: 74px 1fr;
  align-items: start;
  grid-gap: 16px;
  padding: 20px 0 16px;
  border-bottom: 1px solid rgb(0 0 0 / 10%);

  @media (max-width: 720px) {
    padding: 20px 1em 16px;
  }

  .expert_image_box {
    width: 74px;
    height: 74px;
    position: relative;

    .expert_border {
      width: 100%;
      height: 100%;
    }

    .expert_image {
      width: 62px;
      height: 62px;
      border-radius: 50%;
      position: absolute;
      top: 6px;
      left: 6px;
      object-fit: cover;
    }
    .expert_tick {
      width: 16px;
      height: 16px;
      bottom: 6px;
      right: 10px;
      position: absolute;
    }
  }
`;

export const Desc = styled.h6`
  font-size: 12px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 68%);
  padding: 0 0 4px;
`;

export const ExpertName = styled.h3`
  font-size: clamp(16px, 2vw, 18px);
  color: hsl(0deg, 0%, 0%, 80%);
  font-weight: 600;
  margin-bottom: 6px;
`;

export const ViewProfile = styled.div`
  display: flex;
  align-items: center;
  column-gap: 6px;
  margin-top: 8px;
  p {
    color: #ef4e5e;
    font-size: 12px;
    font-weight: 500;
  }
  img {
    width: 6px;
    object-fit: contain;
  }
  &.lowOpacity {
    opacity: 0.4;
  }
`;
